import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinbibwewadi() {



  const cardData = {
"keyword": "Urbania On Rent in Bibwewadi",

"headingDescription":
  "Aaradhya Travels offers reliable Urbania On Rent in Bibwewadi for corporate travel, family functions, weddings, airport transfers, outstation tours, business meetings, and group transportation requirements. Our Force Urbania fleet includes premium pushback seating, air-conditioning, spacious interiors, luggage space, charging points, music systems, and experienced drivers familiar with Bibwewadi and Pune city routes. We ensure safe, comfortable, and punctual transportation with doorstep pickup services across Bibwewadi and nearby Pune locations.",

"topPlaces": [
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station near Mumbai known for toy train rides, viewpoints, dense greenery, and cool weather. It is a peaceful weekend getaway for families and group travelers from Pune and Mumbai."
},
  {
"title": "Mumbai",
"description":
"Mumbai is the financial capital of India known for Marine Drive, Gateway of India, Juhu Beach, Bollywood, shopping streets, and vibrant city life. It is one of the most popular group travel destinations from Pune for corporate tours, shopping trips, and leisure outings."
},

{
"title": "Alibaug",
"description":
"Alibaug is a coastal beach destination near Mumbai known for clean beaches, sea forts, water sports, and relaxed seaside atmosphere. It is a popular group tour destination for short trips from Pune."
},
{
"title": "Lonavala",
"description":
"Lonavala is a famous hill station near Mumbai and Pune known for waterfalls, caves, green valleys, and monsoon beauty. It is a highly visited weekend destination for group bus and Tempo Traveller trips."
},
{
"title": "Khandala",
"description":
"Khandala is known for scenic valleys, misty hills, and natural viewpoints. It is a short and relaxing getaway destination popular among families and group travelers from Mumbai and Pune."
},
{
"title": "Navi Mumbai",
"description":
"Navi Mumbai is a planned city known for clean infrastructure, parks, malls, and business hubs. It is commonly visited for corporate group travel, events, and city tours."
},
{
"title": "Elephanta Caves",
"description":
"Elephanta Caves are UNESCO World Heritage rock-cut caves located on an island near Mumbai known for ancient sculptures and historical significance. It is a popular heritage group tour destination."
},
{
"title": "Imagicaa Theme Park",
"description":
"Imagicaa is a large theme park near Mumbai offering rides, entertainment zones, and water parks. It is a popular destination for school trips, corporate outings, and family group tours."
},
{
"title": "Karjat",
"description":
"Karjat is a scenic green valley near Mumbai known for waterfalls, rivers, resorts, and adventure activities. It is widely chosen for weekend group trips and corporate outings."
},
{
"title": "Khopoli",
"description":
"Khopoli is known for industrial areas, waterfalls nearby, and proximity to Imagicaa theme park. It is a convenient stopover destination for group travel between Pune and Mumbai."
}
],



services: [
  {
    name: "Urbania on Rent Dhankawadi",
    description: "Urbania on rent Dhankawadi service provides luxury transportation for family vacations, airport transfers, sightseeing tours, and corporate travel requirements. Spacious seating and premium interiors ensure smooth journeys suitable for local and outstation transportation. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Dhankawadi Pune. Flexible booking options allow convenient Urbania rental reservations."
  },
  {
    name: "Urbania on Rent Kondhwa",
    description: "Urbania on rent Kondhwa service offers spacious transportation for weddings, office travel, family outings, and airport transfers. Comfortable seating and luggage space ensure pleasant journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Kondhwa Pune. Flexible booking options allow convenient Urbania reservations."
  },
  {
    name: "Urbania on Rent Wanowrie",
    description: "Urbania on rent Wanowrie service provides dependable transportation for sightseeing tours, business meetings, airport pickups, and family group travel. Spacious interiors and modern seating ensure smooth journeys suitable for local and long-distance passenger movement. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Wanowrie Pune. Flexible booking options allow convenient Wanowrie Urbania reservations."
  },
  {
    name: "Urbania on Rent in Bibwewadi",
    description: "Urbania on rent in Bibwewadi service provides premium transportation for airport transfers, corporate travel, sightseeing tours, and family vacations. Spacious seating and smooth travel ensure comfortable journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Bibwewadi Pune. Flexible booking options allow convenient Urbania rental reservations."
  },
  {
    name: "13 Seater Urbania on Rent in Bibwewadi",
    description: "13 seater Urbania on rent in Bibwewadi service offers premium transportation for family outings, airport transfers, office travel, and tourist journeys. Comfortable seating and luggage space ensure pleasant journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and commercial hubs across Bibwewadi Pune. Flexible booking options allow convenient 13 seater Urbania reservations."
  },
  {
    name: "17 Seater Urbania on Rent in Bibwewadi",
    description: "17 seater Urbania on rent in Bibwewadi service provides spacious transportation for weddings, business meetings, office outings, and family group travel. Premium interiors and smooth travel ensure comfortable journeys suitable for medium-sized passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Bibwewadi Pune. Flexible booking options allow convenient 17 seater Urbania reservations."
  },
  {
    name: "Urbania Hire in Bibwewadi Pune",
    description: "Urbania hire in Bibwewadi Pune service offers reliable transportation for airport transfers, sightseeing tours, family vacations, and executive travel requirements. Spacious seating and luggage space ensure smooth journeys suitable for local and outstation transportation. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Bibwewadi Pune. Flexible booking options allow convenient Urbania hire reservations."
  },
  {
    name: "Urbania Booking in Bibwewadi",
    description: "Urbania booking in Bibwewadi service provides dependable transportation for weddings, family trips, office staff travel, and tourist journeys. Comfortable seating and modern interiors ensure pleasant travel experiences suitable for local and long-distance passenger movement. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Bibwewadi Pune. Flexible booking options allow convenient Urbania booking reservations."
  },
  {
    name: "AC Urbania on Rent in Bibwewadi",
    description: "AC Urbania on rent in Bibwewadi service offers premium air-conditioned transportation for weddings, corporate travel, family outings, and airport transfers. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Bibwewadi Pune. Flexible booking options allow convenient AC Urbania reservations."
  },
  {
    name: "Non AC Urbania on Rent in Bibwewadi",
    description: "Non AC Urbania on rent in Bibwewadi service provides affordable transportation for educational tours, office travel, sightseeing journeys, and family outings. Spacious seating and luggage space ensure comfortable journeys suitable for budget-friendly local and outstation travel requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Bibwewadi Pune. Flexible booking options allow convenient non AC Urbania reservations."
  },
  {
    name: "Luxury Urbania on Rent in Bibwewadi",
    description: "Luxury Urbania on rent in Bibwewadi service provides premium transportation with elegant interiors and spacious seating for weddings, corporate travel, airport transfers, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Bibwewadi Pune. Flexible booking options allow convenient luxury Urbania reservations."
  },
  {
    name: "Urbania Rental Service in Bibwewadi",
    description: "Urbania rental service in Bibwewadi provides spacious transportation for educational tours, family outings, corporate travel, and sightseeing trips. Comfortable seating and smooth travel ensure pleasant journeys suitable for local and outstation transportation requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, schools, hotels, and offices across Bibwewadi Pune. Flexible booking options allow convenient Urbania rental service reservations."
  },
  {
    name: "Urbania for Outstation in Bibwewadi",
    description: "Urbania for outstation in Bibwewadi service provides premium long-distance transportation for Goa tours, hill station vacations, pilgrimage journeys, and family trips. Spacious seating and smooth highway travel ensure comfortable journeys suitable for all passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Bibwewadi Pune. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "Urbania for Corporate Events in Bibwewadi",
    description: "Urbania for corporate events in Bibwewadi service provides luxury transportation for office meetings, conferences, employee outings, exhibitions, and executive travel requirements. Spacious interiors and premium seating ensure pleasant journeys suitable for business passenger groups. Professional chauffeurs ensure punctual transportation and dependable pickup services throughout the route. Pickup services are available from offices, IT parks, hotels, and airports across Bibwewadi Pune. Flexible booking options allow convenient corporate event Urbania reservations."
  },
  {
    name: "Urbania for Wedding Function in Bibwewadi",
    description: "Urbania for wedding function in Bibwewadi service offers elegant transportation for marriage ceremonies, bridal travel, guest transportation, and family functions. Spacious seating and premium interiors ensure comfortable journeys suitable for wedding celebrations and event transportation. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding itinerary. Pickup services are available from homes, banquet halls, hotels, and residential areas across Bibwewadi Pune. Flexible booking options allow convenient wedding Urbania reservations."
  },
  {
    name: "Urbania for Airport Pickup Bibwewadi",
    description: "Urbania for airport pickup Bibwewadi service provides dependable transportation for airport transfers, tourist groups, business travelers, and family travel requirements. Spacious seating and luggage space ensure comfortable journeys suitable for local and outstation airport transportation. Professional chauffeurs ensure timely airport pickups and safe driving services throughout the route. Pickup services are available from Pune Airport, homes, offices, hotels, and residential areas across Bibwewadi Pune. Flexible booking options allow convenient airport Urbania reservations."
  },
  {
    name: "Best Urbania Rental in Bibwewadi",
    description: "Best Urbania rental in Bibwewadi service provides premium transportation for sightseeing tours, family vacations, office travel, airport pickups, and tourist journeys. Spacious seating and smooth travel ensure pleasant journeys suitable for local and outstation transportation requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Bibwewadi Pune. Flexible booking options allow convenient Urbania rental reservations."
  },
  {
    name: "Urbania Tempo Traveller in Bibwewadi",
    description: "Urbania tempo traveller in Bibwewadi service offers spacious transportation for family group travel, office outings, weddings, and tourist journeys. Comfortable seating and luggage capacity ensure smooth journeys suitable for medium and large passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Bibwewadi Pune. Flexible booking options allow convenient Urbania tempo traveller reservations."
  },
  {
    name: "Urbania on Rent Near Market Yard",
    description: "Urbania on rent near Market Yard service provides reliable transportation for airport transfers, sightseeing tours, office travel, and family outings. Spacious interiors and smooth travel ensure pleasant journeys suitable for local and outstation transportation requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Market Yard Pune. Flexible booking options allow convenient Market Yard Urbania reservations."
  },
  {
    name: "Urbania on Rent Near Kondhwa",
    description: "Urbania on rent near Kondhwa service offers dependable transportation for family vacations, office travel, airport transfers, and wedding journeys. Comfortable seating and luggage capacity ensure pleasant journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Kondhwa Pune. Flexible booking options allow convenient Kondhwa Urbania reservations."
  },
  {
    name: "Urbania on Rent Near Swargate",
    description: "Urbania on rent near Swargate service provides spacious transportation for sightseeing tours, business meetings, airport pickups, and group travel requirements. Spacious seating and premium interiors ensure smooth journeys suitable for local and outstation transportation. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Swargate Pune. Flexible booking options allow convenient Swargate Urbania reservations."
  },
  {
    name: "Urbania for Family Trip in Bibwewadi",
    description: "Urbania for family trip in Bibwewadi service provides dependable transportation for holiday vacations, sightseeing tours, pilgrimage journeys, and family outings. Spacious seating and comfortable interiors ensure pleasant journeys suitable for local and outstation family group travel. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Bibwewadi Pune. Flexible booking options allow convenient family trip Urbania reservations."
  },
  {
    name: "Urbania for Group Travel in Bibwewadi",
    description: "Urbania for group travel in Bibwewadi service provides spacious transportation for educational tours, sightseeing journeys, office outings, family vacations, and tourist travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium-sized passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Bibwewadi Pune. Flexible booking options allow convenient group travel Urbania reservations."
  }
],

tableData: [
  ["Urbania on Rent Dhankawadi", "Urbania on Rent Kondhwa"],
  ["Urbania on Rent Wanowrie", "Urbania on Rent in Bibwewadi"],
  ["13 Seater Urbania on Rent in Bibwewadi", "17 Seater Urbania on Rent in Bibwewadi"],
  ["Urbania Hire in Bibwewadi Pune", "Urbania Booking in Bibwewadi"],
  ["AC Urbania on Rent in Bibwewadi", "Non AC Urbania on Rent in Bibwewadi"],
  ["Luxury Urbania on Rent in Bibwewadi", "Urbania Rental Service in Bibwewadi"],
  ["Urbania for Outstation in Bibwewadi", "Urbania for Corporate Events in Bibwewadi"],
  ["Urbania for Wedding Function in Bibwewadi", "Urbania for Airport Pickup Bibwewadi"],
  ["Best Urbania Rental in Bibwewadi", "Urbania Tempo Traveller in Bibwewadi"],
  ["Urbania on Rent Near Market Yard", "Urbania on Rent Near Kondhwa"],
  ["Urbania on Rent Near Swargate", "Urbania for Family Trip in Bibwewadi"],
  ["Urbania for Group Travel in Bibwewadi", "Urbania on Rent Dhankawadi"]
],





 whychoose: [
      {
        WhyChooseheading: "Reliable Urbania on Rent in Bibwewadi",
        WhyChoosedescription: "Aaradhya Travels provides reliable Urbania rental service in Bibwewadi with luxury vehicles, professional drivers, and smooth travel arrangements for family trips, corporate tours, weddings, and group travel."
      },
      {
        WhyChooseheading: "Affordable Luxury Urbania Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Urbania on rent in Bibwewadi with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Urbania Booking Service",
        WhyChoosedescription: "Our Force Urbania rental service in Bibwewadi operates 24 hours for airport transfers, weddings, outstation tours, pilgrimage trips, corporate outings, and luxury group travel."
      },
      {
        WhyChooseheading: "Comfortable AC Luxury Urbania Vehicles",
        WhyChoosedescription: "All Urbania vehicles provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for premium and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, pilgrimage journeys, sightseeing travel, and multi-day outstation packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Urbania Options",
        WhyChoosedescription: "Customers can choose from 9 seater, 13 seater, 14 seater, and 17 seater luxury Force Urbania vehicles suitable for family vacations, corporate groups, wedding guests, and tourist travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Bibwewadi & Nearby Areas",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Bibwewadi, Market Yard, Dhankawadi, Katraj, Swargate, Camp, Kondhwa, Pune Station, and nearby Pune locations for hassle-free travel."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Outstation Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation luxury group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Urbania on rent in Bibwewadi?", answer: "Urbania on rent in Bibwewadi provides luxury group transportation using premium Force Urbania vehicles for family tours, corporate travel, weddings, and outstation journeys." },
    { question: "Is Urbania booking available 24 hours in Bibwewadi?", answer: "Yes, Aaradhya Travels provides 24/7 Force Urbania rental service in Bibwewadi." },
    { question: "Which seating options are available in Urbania?", answer: "Aaradhya Travels offers 9 seater, 13 seater, 14 seater, and 17 seater Force Urbania vehicles for different group travel requirements." },
    { question: "Can I book Urbania for outstation trips from Bibwewadi?", answer: "Yes, customers can book Force Urbania for hill stations, pilgrimage tours, holiday trips, destination weddings, and outstation travel from Bibwewadi Pune." },
    { question: "Do you provide Urbania for corporate events in Bibwewadi?", answer: "Yes, Aaradhya Travels provides Force Urbania service for office outings, conferences, employee transport, and corporate travel." },
    { question: "Are all Urbania vehicles air-conditioned?", answer: "Yes, all Force Urbania vehicles are fully air-conditioned and maintained for comfortable luxury travel." },
    { question: "Can I book Urbania online in Bibwewadi?", answer: "Yes, customers can easily book Force Urbania rental service online or through phone booking." },
    { question: "Do you provide Pune Airport pickup and drop service?", answer: "Yes, Aaradhya Travels provides airport pickup and drop service using luxury Force Urbania vehicles." },
    { question: "Are Urbania rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Urbania rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Jadhav",
    feedback:
      "Traveling from Bibwewadi with Aaradhya Travels in a Force Urbania was a very comfortable experience. The vehicle felt premium, and the group could travel together smoothly without any discomfort.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback:
      "Aaradhya Travels provided a Force Urbania on rent in Bibwewadi for our family outing, and the journey was very well managed. The ride was spacious, clean, and extremely comfortable for everyone.",
    rating: 5
  }
];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];
















  return (
    <div>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/91.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentinbibwewadi ;